{
  "views": {
    "assignedToOthersView": {
      "title": "My tasks assigned to others",
      "noData": {
        "title": "No tasks assigned to others",
        "description": "There is no data to display. Try adjusting the filters to find relevant results."
      }
    },
    "uploadTasksView": {
      "title": "Upload tasks from file",
      "description": "Quickly add multiple tasks by uploading an Excel file. Your file should include the following columns:",
      "titleWithData": "{{tasksDetected}} tasks detected",
      "descriptionWithData": "You have successfully uploaded your Excel file. Below, you can review the data to ensure everything is correct. If needed, you can make changes in the Excel file and upload it again.",
      "uploadActionButton": "Upload .xls file with tasks",
      "upload": "Save & upload"
    }
  },
  "components": {
    "recurringTaskPage": {
      "overdueTag": "{{count}} Expired",
      "taskOverdue_one": "Expired ({{count}} day)",
      "taskOverdue_other": "Expired ({{count}} days)",
      "recurringTasksSectionTitle": "Recurring tasks"
    },
    "recurringTaskForm": {
      "errors": {
        "validation": {
          "timeToCompleteRequired": "Please select time to complete",
          "atLeastOneWeekday": "At least one weekday must be selected when repeating weekly",
          "monthlyOptionRequired": "Select either a day of the month or a weekday of the month",
          "endDateBeforeStartDate": "End date must be on or after the start date"
        }
      },
      "header": {
        "edit": "Edit Recurring Task",
        "create": "New Recurring Task"
      },
      "submitButton": {
        "edit": "Save",
        "create": "Create"
      },
      "setRecurrenceDialog": {
        "title": "Set recurrence"
      },
      "reccurenceMessage": {
        "mainPart": "Will recur {{recurrenceSummary}} starting from {{startDate}}",
        "onSelectedWeekdays": "on selected week days ({{weekdays}})",
        "notSelected": "not selected",
        "onSelectedMonthDay": "on {{dayOfMonth}} day of the month",
        "onSelectedMonthOnTheDay": "on the {{ordinalWeek}} {{weekdayName}} of the month",
        "repeatOptions": {
          "daily": "Daily",
          "weekly": "Weekly",
          "monthly": "Monthly"
        },
        "recurringType": {
          "day_one": "everyday",
          "day_other": "every {{count}} days",
          "week_one": "every week",
          "week_other": "every {{count}} weeks",
          "month_one": "every month",
          "month_other": "every {{count}} months"
        }
      },
      "fields": {
        "repeat": "Repeat",
        "timeToComplete": "Time to complete the task",
        "startDate": "Start",
        "endDate": "End",
        "onDay": "On day",
        "at": "At",
        "onThe": {
          "label": "On the",
          "options": {
            "first": "First",
            "second": "Second",
            "third": "Third",
            "fourth": "Fourth",
            "last": "Last"
          }
        },
        "onWeekDay": {
          "label": "On day",
          "hint": "you can select more than one day"
        }
      }
    },
    "taskForm": {
      "buttons": {
        "createNextStep": "Complete & Add Next Step"
      },
      "header": {
        "edit": "Edit Task",
        "create": "New Task",
        "duplicate": "Duplicate task",
        "createNextStep": "Next Step Task",
        "preview": "Task details"
      },
      "submitButton": {
        "edit": "Save",
        "create": "Create",
        "duplicate": "Save duplicated task"
      },
      "fields": {
        "completed": "Mark as completed",
        "priority": "Priority",
        "organization": "Organization",
        "vendor": "Vendor",
        "author": "Author",
        "assignee": "Assigned person",
        "estimatedTime": {
          "field": "Estimated time",
          "description": "Set the estimated time to complete this task"
        },
        "deadline": {
          "field": "Due Date",
          "description": "Select the date you'd like to complete this task by"
        }
      }
    },
    "subtaskForm": {
      "editTitle": "Edit Subtask",
      "createTitle": "New Subtask",
      "submitCreate": "Create Subtask",
      "submitEdit": "Save"
    },
    "managerPanel": {
      "membersList": {
        "assignedTasks": "{{taskCount}} assigned tasks",
        "overDueTasks": "{{taskCount}} Overdue"
      },
      "new": {
        "buttonText": "New",
        "task": "Task",
        "member": "Manage members",
        "inviteDialog": {
          "title": "Manage team members",
          "submitButton": "Save"
        }
      }
    },
    "importTaskTable": {
      "successMessage": "Tasks imported successfully",
      "errorMessage": "We have detected {{errorCount}} errors in your file. Click here to see details.",
      "errors": {
        "invalidFileType": "Invalid file type",
        "errorImportingFile": "Error importing file",
        "maxRowsExceeded": "The maximum number of rows is {{maxRows}}"
      },
      "errorDialog": {
        "title": "There are {{errorCount}} errors",
        "errorMessage": "There was an error in row {{rowNumber}} in column {{columnPath}}: {{errorDetail}}",
        "errorPleaseNote": "Please note!",
        "errorDescription": "Rows are counted starting from the row that specifies the column names, not from the first row of the file."
      },
      "columnNames": {
        "title": "Title",
        "description": "Description",
        "priority": "Priority",
        "deadline": "Due Date",
        "referenceName": "Reference Name",
        "referenceUrl": "URL",
        "category": "Type",
        "status": "Status"
      },
      "columnDescriptions": {
        "title": "Maximum length: {{maxLength}} characters",
        "description": "Maximum length: {{maxLength}} characters",
        "priority": "Must be one of the following: {{allowedValues}}",
        "deadline": "Must be a proper date - task deadline",
        "referenceName": "Display name of the reference",
        "referenceUrl": "Reference URL ",
        "category": "Must be one of the following: {{allowedValues}}",
        "status": "Defaults to \"new\" if omitted. Must be one of the following: {{allowedValues}}"
      }
    }
  },
  "notifications": {
    "success": {
      "TASK_CREATION_SUCCESS": {
        "description": "Task has been created successfully"
      },
      "TASK_EDITION_SUCCESS": {
        "description": "Task has been updated successfully"
      },
      "TASK_DELETION_SUCCESS": {
        "description": "Task has been deleted successfully"
      },
      "TASK_RESTORATION_SUCCESS": {
        "description": "Task has been restored successfully"
      },
      "TASK_LOG_TIME_SUCCESS": {
        "description": "Time has been logged successfully"
      },
      "SUBTASK_CREATION_SUCCESS": {
        "description": "Subtask has been created successfully"
      },
      "SUBTASK_EDITION_SUCCESS": {
        "description": "Subtask has been updated successfully"
      },
      "SUBTASK_DELETION_SUCCESS": {
        "description": "Subtask has been deleted successfully"
      },
      "RECURRING_TASK_CREATION_SUCCESS": {
        "description": "Recurring task has been created successfully"
      },
      "RECURRING_TASK_EDITION_SUCCESS": {
        "description": "Recurring task has been updated successfully"
      },
      "RECURRING_TASK_DELETION_SUCCESS": {
        "description": "Recurring task has been deleted successfully"
      },
      "TAG_CREATION_SUCCESS": {
        "description": "Tag has been created successfully"
      },
      "TAG_DELETION_SUCCESS": {
        "description": "Tag has been deleted successfully"
      }
    }
  },
  "enums": {
    "ActionType": {
      "fileUpload": "File upload",
      "meeting": "Meeting link",
      "link": "Link"
    },
    "RecurrenceInterval": {
      "day": "Day",
      "week": "Week",
      "month": "Month"
    },
    "recurringCronType": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun",
      "full": {
        "mon": "Monday",
        "tue": "Tuesday",
        "wed": "Wednesday",
        "thu": "Thursday",
        "fri": "Friday",
        "sat": "Saturday",
        "sun": "Sunday"
      }
    }
  }
}
